import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
// import ReactDOM from 'react-dom'
// import Search from 'react-search'

import ButStItem from '../containers/ButStItem'
import StatisticiNumere from '../containers/StatisticiNumere'

// import NrFavorite from '../containers/NrFavorite';
import { acConSizeChange } from '../actions/acConSizeChange';
import { acAxiosRequest } from '../actions/acAxiosRequest'
import LottoLive from '../theme/LottoLive';
import Ora from '../containers/Ora'

class ColoanaSt extends React.Component {

    constructor() {
        super();
        this.state = {
            sVal: '',
            vizual: true
        };
    }
    updateSVal(e) {
        this.setState({ sVal: e.target.value })
    }
    componentDidMount() {
        if (this.props.nrFavorite === null) {

            var activeLot = null
            if (!this.props.activeLot) {
                if (this.props.loterii && this.props.loterii.length > 0) {
                    activeLot = this.props.loterii[0].name_lot.replace(/ /g, "_")
                }
            } else {
                activeLot = this.props.activeLot.name_lot.replace(/ /g, "_")
            }
            if (activeLot) {
                var nrFav = {
                    ruta: this.props.appProps.ruta,
                    reducer: 'NR_FAVORITE',
                    request: 'get_user_favorites',
                    value: 'lottery_name=' + activeLot,
                    error: '5000',
                    reducer2: 'NR_FAVORITE_MIDDLE',
                    newParam: this.props.sessionParam
                }

                this.props.acAxiosRequest(nrFav);
            }

        } else {
            nrFav = {
                ruta: this.props.appProps.ruta,
                reducer: 'NR_FAVORITE_MIDDLE',
                request: 'get_user_favorites',
                value: 'lottery_name=' + this.props.loterii[0].name_lot.replace(/ /g, "_"),
                error: '5000',
                newParam: this.props.sessionParam
            }
            this.props.acAxiosRequest(nrFav);
        }

    }
    componentDidUpdate(prevProps, prevState) {
        if ((this.props.activeLot !== null) && (prevProps.activeLot !== null)) {
            if (prevProps.activeLot.name_lot !== this.props.activeLot.name_lot) {

                var statistici = {
                    ruta: this.props.appProps.ruta,
                    reducer: 'STATISTICI',
                    request: 'get_stat_rounds',
                    value: 'lottery_prefix=' + this.props.activeLot.prefix,
                    error: '6000',
                    extra: this.props.activeLot.name_lot,
                    newParam: this.props.sessionParam
                }

                this.props.acAxiosRequest(statistici);
                var nrFav = {
                    ruta: this.props.appProps.ruta,
                    reducer: 'NR_FAVORITE_MIDDLE',
                    request: 'get_user_favorites',
                    value: 'lottery_name=' + this.props.activeLot.name_lot.replace(/ /g, "_"),
                    error: '5000',
                    newParam: this.props.sessionParam
                }
                this.props.acAxiosRequest(nrFav);
            }
        }
        if (this.refColSt) {
            var dimensions = this.refColSt
            if (this.props.conSizeChange.colSt !== dimensions.offsetHeight) {
                this.props.acConSizeChange({ colSt: dimensions.offsetHeight })
            }

        }

    }
    live() {
        if ((this.props.appProps.live === true) && (this.state.vizual === true) && (this.props.activeLot !== null)) {
            if (this.props.conSizeChange.appW && this.props.conSizeChange.appW < 1000) {
                return (
                    <div className="con-lotto-resp-st">
                        <LottoLive />
                    </div>)
            }
        } else {
            return <div></div>
        }
    }
    disableVizual() {
        this.setState({ vizual: !this.state.vizual });
    }
    nrStatistici() {
        if (this.props.conSizeChange.appW > 999 && this.props.loterii) {
            return (<StatisticiNumere />)
        }
    }
    render() {
        if (this.props.multiLang && this.props.loterii) {
            
            if (this.props.conSizeChange.appW && this.props.conSizeChange.appW < 1000) {
                return (
                    <div className={"col-st  "} ref={(f) => this.refColSt = f}>
                        <Ora />
                        <div className="search">
                            <input className="search-input" type="text" onChange={this.updateSVal.bind(this)} value={this.state.sVal} placeholder={this.props.multiLang.search.txt} />
                        </div>
                        <div className="module-header">
                            <div>
                                <span> {this.props.multiLang.headerSt.txt}</span>
                                <span className="close-mobile-lot">X</span>
                            </div>
                        </div>
                        <nav>
                            <ButStItem filtru={this.state.sVal} />
                        </nav>
                        <div className="nav-footer"></div>
                        {this.live()}
                        {this.nrStatistici()}
                    </div>
                )
            } else {
                return (
                    <div className={"col-st  "} ref={(f) => this.refColSt = f}>
                        <Ora />
                        <div className="search">
                            <input className="search-input" type="text" onChange={this.updateSVal.bind(this)} value={this.state.sVal} placeholder={this.props.multiLang.search.txt} />
                        </div>
                         {/* start top loterii */}
                         <div className="module-header">
                            <div>
                                <span> {this.props.multiLang.headerStTop.txt}</span>
                                <span className="close-mobile-lot">X</span>
                            </div>
                        </div>
                        <nav className="lotteries-nav top-lotteries">
                            <ButStItem filtru={this.state.sVal} topLoterii={true} />
                        </nav>
                        {/* end top loterii  */}
                        {/* start loterii normale */}
                        <div className="module-header">
                            <div>
                                <span> {this.props.multiLang.headerSt.txt}</span>
                                <span className="close-mobile-lot">X</span>
                            </div>
                        </div>
                        <nav className="lotteries-nav">
                            <ButStItem filtru={this.state.sVal} topLoterii={false} />
                        </nav>
                        {/* end loterii normale */}
                        <div className="nav-footer"></div>
                        {this.live()}
                        {this.nrStatistici()}
                    </div>
                )
            }
        } else {
            return <div></div>
        }
    }
}
function mapStateToProps(state) {
    return {
        appProps: state.appProps,
        multiLang: state.multiLang,
        conSizeChange: state.conSizeChange,
        loterii: state.loterii,
        nrStatistici: state.nrStatistici,
        nrFavorite: state.nrFavorite,
        activeLot: state.activeLot,
        defaultVal: state.defaultVal,
        sessionParam: state.sessionParam
    }
}
function matchDispatchToProps(dispatch) {
    return bindActionCreators({
        acAxiosRequest: acAxiosRequest,
        acConSizeChange: acConSizeChange
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(ColoanaSt);
